export function changeMediaListener({
  phoneHandler,
  phoneAndTabletHandler,
  tabletAndDesktopHandler,
  desktopHandler,
  customSizes,
}) {
  const supportsAddEventListener =
    "addEventListener" in window.matchMedia("(min-width: 0px)");

  function listenMedia(handler, query) {
    const media = window.matchMedia(query);

    const mediaHandler = function () {
      if (media.matches) {
        handler();
      }
    };

    mediaHandler();

    if (supportsAddEventListener) {
      media.addEventListener("change", mediaHandler);
    } else {
      media.addListener(mediaHandler);
    }
  }

  phoneHandler && listenMedia(phoneHandler, "(max-width: 767px)");
  phoneAndTabletHandler &&
    listenMedia(phoneAndTabletHandler, "(max-width: 1023px)");
  tabletAndDesktopHandler &&
    listenMedia(tabletAndDesktopHandler, "(min-width: 768px)");
  desktopHandler && listenMedia(desktopHandler, "(min-width: 1024px)");
  customSizes?.length &&
    customSizes.forEach((item) => listenMedia(item.handler, item.query));
}
